/**
 * 咨询师
 */
const App = () => import('@/module/index/layout/App.vue')
const consultant = () => import('@/module/index/pages/consultant/index.vue')
const consultantdetail = () => import('@/module/index/pages/consultant/detail.vue')
const consultantfinish = () => import('@/module/index/pages/consultant/finish.vue')
const consultantFinishDetail = () => import('@/module/index/pages/consultant/finishDetail.vue')

export default {
  path: '/consultant',
  component: App,
  redirect: '/consultant/index',

  children: [{
    path: '/consultant/index',
    component: consultant
  },
  {
    path: '/consultant/index/:id',
    component: consultantdetail
  },
  {
    path: '/consultant/finish',
    component: consultantfinish
  },
  {
    path: '/consultant/finish/:id',
    component: consultantFinishDetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/consultant.js